import { lazy } from "react";

const MarketplaceV2 = lazy(() => import("features/Explore/v2"));
const StrategyDetailV2 = lazy(() => import("features/Explore/v2/Detail"));
const CollectionDetailV2 = lazy(() =>
  import("features/Explore/v2/CollectionDetail")
);

export const MARKETPLACE_PATH = "/marketplace";
export const MARKETPLACE_STRATEGY_DETAIL_PATH =
  "/marketplace/strategy/:id/detail";

// V2 Routes
export const MARKETPLACE_V2_PATH = "/explore";
export const MARKETPLACE_V2_STRATEGY_DETAIL_PATH =
  "/explore/strategy/:id/detail";
export const MARKETPLACE_V2_COLLECTION_PATH =
  "/explore/collection/:slug/detail";

export const exploreRoutesV2 = [
  {
    path: MARKETPLACE_V2_PATH,
    component: <MarketplaceV2 />,
  },
  {
    path: MARKETPLACE_V2_STRATEGY_DETAIL_PATH,
    component: <StrategyDetailV2 />,
  },
  {
    path: MARKETPLACE_V2_COLLECTION_PATH,
    component: <CollectionDetailV2 />,
  },
];
